/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Row,
    CardHeader,
    Col,
    Form,
    Badge,
    Button,
    Container,
    Modal, ModalHeader, ModalBody
} from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";

export default function DetailKasbon(props) {
    const token = localStorage.token;
    // const [image1, setImage1] = useState("");
    // const [image2, setImage2] = useState("");
    // const [image3, setImage3] = useState("");
    // const [image4, setImage4] = useState("");
    // const [image5, setImage5] = useState("");
    const [v, setV] = useState([])

    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/cash-bon/get/${props.match.params.id}`, { headers })
            .then((data) => {
                const res = data.data.response;
                setV(res)
                getAllDokumentPettyCash(res.id)
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
    }

    return (
        <>
            <div>
                <SimpleHeaderMobile to="/mobile/kasbon/page" />
                <Container className="mt--6" fluid>
                    <>
                        <Card className="shadow mb-4">
                            <CardHeader className="bg-primary text-white">
                                <h5 className="mb-0 text-white">📄 Detail Pinjaman</h5>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Tanggal</Col>
                                    <Col xs="7"> {v.created_at}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Kode</Col>
                                    <Col xs="7"> {v.cash_bon_code}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Nama</Col>
                                    <Col xs="7"> {v.name}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Request</Col>
                                    <Col xs="7"> {formatRupiah(v.nominal_request ?? 0)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">ACC</Col>
                                    <Col xs="7"> {formatRupiah(v.nominal_approval ?? 0)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Tenor</Col>
                                    <Col xs="7"> {v.tenor ?? 0} Bulan</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Keterangan</Col>
                                    <Col xs="7"> {v.keterangan ?? "-"}</Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </>
                </Container>
            </div>
        </>
    );
}
